import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import WorkOrderReports from "./WorkOrderReports";
import ReportView from "./ReportView";

const WorkOrderReportsContainer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";
  const { reportId } = useParams<{ reportId?: string }>();
  const [currentView, setCurrentView] = useState<"list" | "report">(
    reportId ? "report" : "list"
  );
  const [selectedReportId, setSelectedReportId] = useState<string | null>(
    reportId || null
  );

  const handleReportSelect = (reportId: string) => {
    setSelectedReportId(reportId);
    setCurrentView("report");
    navigate(`/work-order-reports/${reportId}${flowTypeQuery}`);
  };

  const handleBackToList = () => {
    setCurrentView("list");
    setSelectedReportId(null);
    navigate(`/work-order-reports${flowTypeQuery}`);
  };

  const handleDrillDown = (reportId: string, filters?: any) => {
    setSelectedReportId(reportId);
    navigate(`/work-order-reports/${reportId}${flowTypeQuery}`);
  };

  if (currentView === "report" && selectedReportId) {
    return (
      <ReportView
        reportId={selectedReportId}
        onBack={handleBackToList}
        // onDrillDown={handleDrillDown}
      />
    );
  }

  return <WorkOrderReports onReportSelect={handleReportSelect} />;
};

export default WorkOrderReportsContainer;
